let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("as2Yi")).then(() => parcelRequire('3geiu'));